export type FilterOption = {
  id: string;
  name: string;
  parentName?: string;
  logo?: string | null;
  children?: FilterOption[];
};

export type LibraryFilterKey =
  | "category"
  | "brand"
  | "supplier"
  | "color"
  | "shape"
  | "material"
  | "style"
  | "pattern"
  | "room"
  | "price";

export type LibraryFilterChip = {
  key: LibraryFilterKey;
  id: string;
  label: string;
};

export type LibraryFilterState = {
  categoryIds: string[];
  brandNames: string[];
  supplierIds: string[];
  colorIds: string[];
  shapeIds: string[];
  materialIds: string[];
  styleIds: string[];
  patternIds: string[];
  roomIds: string[];
  priceFrom?: number;
  priceTo?: number;
};

export type LibraryFilterFacets = {
  categories: FilterOption[];
  brands: FilterOption[];
  suppliers: FilterOption[];
  colors: FilterOption[];
  shapes: FilterOption[];
  materials: FilterOption[];
  styles: FilterOption[];
  patterns: FilterOption[];
  rooms: FilterOption[];
  priceMin?: number | null;
  priceMax?: number | null;
};

export const EMPTY_LIBRARY_FILTERS: LibraryFilterState = {
  categoryIds: [],
  brandNames: [],
  supplierIds: [],
  colorIds: [],
  shapeIds: [],
  materialIds: [],
  styleIds: [],
  patternIds: [],
  roomIds: [],
};
